import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListIcon from '@mui/icons-material/List';

const Stages = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            <div style={{ width: '80%', display: 'flex', margin:'auto', marginTop:'2rem', marginBottom:'1rem'}}>
                <ListIcon style={{ color: '#10609e' }}/>
                <p style={{ width: '80%', marginTop: '3px', marginLeft:'1rem', fontWeight:'bold', color:'#10609e'  }}>What to do at each stage of the study?</p><br />
            </div>
            <Accordion className='accordian_members' expanded={expanded === 'panel25'} onChange={handleChange('panel25')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What do I need to do before training?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ marginLeft: '2rem' }}>
                            <li>Arrange training days including a practice day in a childcare centre with children.</li>
                            <li>Translate all documents in the CloudStor Protocol Training Materials folder and upload to your CloudStor Country folder for the Coordinating Centre to add to REDCap.</li>
                            <li>Finalise equipment details (your own or borrowing from the Coordinating Centre).</li>
                            <li>Send the list of your accelerometer serial numbers to the Coordinating Centre.</li>
                            <li>If using your own iPads, download the latest versions of REDCap, EYToolbox and Bubble level apps.</li>
                            <li>Set up the REDCap and EYToolbox apps in line with the SUNRISE protocol.</li>
                            <li>Install ActiGraph license on a computer/laptop.</li>
                            <li>Obtain all necessary ethics and other approvals and share these with the UOW Coordinating Centre.</li>
                            <li>Finalise and sign the Collaboration Agreement.</li>
                            <li>Arrange a Zoom meeting with the Coordinating Centre team 1 week prior to the training.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel26'} onChange={handleChange('panel26')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What do I need to do before data collection?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ marginLeft: '2rem' }}>
                            <li>Complete Kahoots quizzes.</li>
                            <li>Upload any training videos if requested.</li>
                            <li>Send test data for REDCap and EYToolbox games from each iPad.</li>
                            <li>Confirm translations are correct in REDCap.</li>
                            <li>Communicate to the Coordinating Centre when data collection will start.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel27'} onChange={handleChange('panel27')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What do I need to during data collection?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ marginLeft: '2rem' }}>
                            <li>Communicate to the SUNRISE Coordinating Centre when the first upload of data to REDCap and EYToolbox has occurred to confirm it has been received.</li>
                            <li>Update the CloudStor checklist each week.</li>
                            <li>Sync EYToolbox and REDCap data over a good Wi-Fi connection each week.</li>
                            <li>Upload accelerometry files to CloudStor each week.</li>
                            <li>Check data in REDCap for incomplete records and enter missing data.</li>
                            <li>Give regular updates to the Coordinating Centre about data collection.</li>
                            <li>Resolve any missing data when data checks are received from the Coordinating Centre.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel28'} onChange={handleChange('panel28')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What do I need to do after data collection?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ marginLeft: '2rem' }}>
                            <li>Communicate to the SUNRISE Coordinating Centre when data collection is complete.</li>
                            <li>Update and check the CloudStor checklist for completion.</li>
                            <li>Check data in REDCap for incomplete records and enter missing data.</li>
                            <li>Sync EYToolbox and REDCap data over a good Wi-Fi and confirm all data has been received by the Coordinating Centre.</li>
                            <li>Ensure all accelerometry files have been uploaded to CloudStor.</li>
                            <li>Promptly resolve any missing data once the final data check is received from the Coordinating Centre.</li>
                            <li>Return any borrowed equipment to the Coordinating Centre.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>

        </>
    )
}

export default Stages
